<template>
  <div class="wechat-login">
    <div class="wechat-panel">
      <div class="qrcode" id="qrcode"></div>
      <div class="qrcode-btn">
        <el-button type="text" @click="emitParentStatus('login')">快捷登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  function getQueryString(name, url) {
    console.log("url", url)
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = url.substr(url.indexOf("?")).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  }

  export default {
    name: "wechatLogin",
    props: {
      isMobile: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    methods: {
      emitParentStatus(str) {
        this.$emit('changePanel', str)
      }
    },
    mounted() {
      let href = window.location;
      //不需要跳转回来的话,服务端默认跳转到/industry
      href = "";
      let redirect_uri= encodeURIComponent('http://enplus.org.cn/high/account/wxOpenLogin?returnUrl=' + href)
      new WxLogin({
        id: "qrcode",
        appid: "wx9d41989bbf785719",
        scope: "snsapi_login",
        redirect_uri: redirect_uri,
        style: "black",
        state: "",
        self_redirect: false
      })
    }
  }
</script>

<style lang="scss" scoped>
  .wechat-login {
    .wechat-panel {
      .qrcode {
        width: p2r(300px);
        margin: 0 auto;
      }

      .qrcode-btn {
        text-align: center;

        > > > button {
          color: $bloodRed;
        }
      }
    }

    .impowerBox {
      .title {
        font-size: 24px;
        color: #333333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/loginPanel/wechatLogin.vue